<template>
  <div>
    <div class="row HeaderArchiveItems">
      <div class="col-sm-1">
        <h4>Tipologia</h4>
      </div>
      <div class="col-sm-3">
        <h4>Nome File</h4>
      </div>
      <div class="col-sm-2">
        <h4>Data Caricamento</h4>
      </div>
      <div class="col-sm-2">
        <h4>Categoria</h4>
      </div>
      <div class="col-sm-2">
        <h4>Tag</h4>
      </div>
      <div class="col-sm-2">
        <h4>Azioni</h4>
      </div>
    </div>

    <div class="row">
      <div
        class="col-12 ArchiveItem"
        v-for="(file, index) in files"
        :key="index"
      >
        <FileCard
          :file="file"
          @preview="openFilePreviewDialog($event)"
          @edit="openEditFileDialog($event)"
          @deleted="handleDeletedElement()"
          @thumbnail="handleThumbnailDialog($event)"
        />
      </div>
    </div>

    <FilePreviewDialog :file="selectedFile" />
  </div>
</template>

<script>
export default {
  props: ["files"],
  data() {
    return {
      selectedFile: null,
    };
  },
  methods: {
    openFilePreviewDialog(file) {
      this.selectedFile = file;

      this.$root.$emit("bv::show::modal", "file-preview-modal");
    },

    handleDeletedElement() {
      this.$emit("deleted", true);
    },

    openEditFileDialog(file) {
      this.$emit("edit", file);
    },

    handleThumbnailDialog(url) {
      this.$emit("thumbnail", url);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/components/Drive.vue